import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=346227a4&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346227a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346227a4')) {
      api.createRecord('346227a4', component.options)
    } else {
      api.reload('346227a4', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=346227a4&scoped=true", function () {
      api.rerender('346227a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Logout.vue"
export default component.exports